import styled from "styled-components";
import { Headline } from "root/libs/ui-components/src";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { RadioCardTitle } from "../../RadioCards/styled";

export const PresetSelectorHeadline = styled(Headline)`
  margin-top: var(--dui-size-space-10x) !important;
  margin-bottom: var(--dui-size-space-10x);
`;

export const PresetSelectorGroup = styled.div`
  ${RadioCardTitle} {
    @media screen and (min-width: ${breakpoints.desktop}) {
      span {
        font-size: var(--dui-size-font-md);
      }
    }
  }
`;
